var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63027 11.4715L13.4614 6.42633C13.5415 6.34347 13.6051 6.24488 13.6485 6.13626C13.6919 6.02763 13.7143 5.91113 13.7143 5.79345C13.7143 5.67578 13.6919 5.55927 13.6485 5.45065C13.6051 5.34203 13.5415 5.24344 13.4614 5.16057C13.3012 4.99455 13.0844 4.90137 12.8586 4.90137C12.6327 4.90137 12.4159 4.99455 12.2557 5.16057L7.98043 9.57291L3.74788 5.16057C3.58767 4.99455 3.37095 4.90137 3.14506 4.90137C2.91916 4.90137 2.70245 4.99455 2.54224 5.16057C2.46145 5.24313 2.39717 5.34158 2.35314 5.45021C2.30911 5.55885 2.28619 5.67552 2.28572 5.79345C2.28619 5.91139 2.30911 6.02806 2.35314 6.13669C2.39717 6.24533 2.46145 6.34378 2.54224 6.42633L7.37333 11.4715C7.4534 11.562 7.55058 11.6342 7.65875 11.6836C7.76691 11.733 7.88372 11.7585 8.0018 11.7585C8.11989 11.7585 8.2367 11.733 8.34486 11.6836C8.45302 11.6342 8.5502 11.562 8.63027 11.4715Z",
    fill: "#5932EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.0995c4d37bf2fbe676a73485edffab8e.svg";
export { ForwardRef as ReactComponent };